import React from 'react'
import { mamorioIcon } from '../../icons'
import './GroupMamorioCount.css'

type GroupMamorioCountProps = {
  mamoriosCount?: number | null
}

const GroupMamorioCount = ({ mamoriosCount }: GroupMamorioCountProps) => {
  if (typeof mamoriosCount !== 'number' || !Number.isFinite(mamoriosCount) || mamoriosCount <= 0) {
    return null
  }

  return (
    <div
      className="group-mamorio-count"
      data-testid="group-mamorio-count"
      aria-label={`登録MAMORIO数 ${mamoriosCount}`}
    >
      <img src={mamorioIcon} alt="" />
      <strong>{mamoriosCount}</strong>
    </div>
  )
}

export default GroupMamorioCount
